<template lang="html">
  <USelectMenu
    v-model="selectedSort"
    :items="sortOptions"
    value-key="value"
    placeholder="Сортировка"
    variant="none"
    :searchInput="false"
    :ui="{ content: 'min-w-60' }"
    class="catalog-sort-selector cursor-pointer text-sm text-neutral-500 hover:text-neutral-700"
  />
</template>

<script setup lang="ts">
import { SortDirection } from '#Common/models'
import { WellKnownAttribute } from '#Products/models/Pim/Enums/WellKnownAttribute'

const props = defineProps<{
  modelValue?: {
    sortField: string
    sortDirection: SortDirection
  }
}>()

const emit = defineEmits<{
  'update:modelValue': [
    value: {
      sortField: string
      sortDirection: SortDirection
    },
  ]
}>()

const { wellKnown } = await useAttributes()

const sortOptions = [
  {
    label: 'По витрине',
    value: JSON.stringify({
      sortField: 'manual',
      sortDirection: SortDirection.ASC,
    }),
  },
  {
    label: 'Дешевле',
    value: JSON.stringify({
      sortField: wellKnown.value[WellKnownAttribute.Price],
      sortDirection: SortDirection.ASC,
    }),
  },
  {
    label: 'Дороже',
    value: JSON.stringify({
      sortField: wellKnown.value[WellKnownAttribute.Price],
      sortDirection: SortDirection.DESC,
    }),
  },

  {
    label: 'Старее',
    value: JSON.stringify({
      sortField: 'updated',
      sortDirection: SortDirection.ASC,
    }),
  },
  {
    label: 'Новее',
    value: JSON.stringify({
      sortField: 'updated',
      sortDirection: SortDirection.DESC,
    }),
  },
]

const defaultSort = sortOptions[0]!.value

const selectedSort = computed({
  get: () => {
    if (!props.modelValue) {
      return defaultSort // По умолчанию "По витрине" (ручной порядок)
    }
    return JSON.stringify({
      sortField: props.modelValue.sortField,
      sortDirection: props.modelValue.sortDirection,
    })
  },
  set: (value: string) => {
    const parsed = JSON.parse(value)
    emit('update:modelValue', parsed)
  },
})
</script>
